import Button from 'components/atoms/Button';

export default function BackButton({ onClick, isVisible }: { onClick: () => void; isVisible: boolean }) {
  if (!isVisible) return null;
  return (
    <Button
      className="absolute l-[24px] t-[54px]"
      onClick={onClick}
      icon="chevron-left"
      dataDurableId="ModalBackButton"
      iconSize={34}
    />
  );
}
